import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { NAME_REDUCER } from './constants';
import { IState } from './types/reducer';

const initialState: IState = {
  billDetail: null,
  receiptLoading: true,
  coupons: null,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.getBillDetail.success, (state, { payload }) => {
        state.billDetail = payload;
      })
      .addCase(actions.setReceiptLoading, (state, { payload }) => {
        state.receiptLoading = payload;
      })
      .addCase(actions.getBillCoupons.success, (state, { payload }) => {
        state.coupons = payload;
      })
      ;
  },
});

const billServiceReducer = Slice.reducer;
export default billServiceReducer;
